import { render, staticRenderFns } from "./HomePendingList.vue?vue&type=template&id=34356cbc"
import script from "./HomePendingList.vue?vue&type=script&lang=js"
export * from "./HomePendingList.vue?vue&type=script&lang=js"
import style0 from "./HomePendingList.vue?vue&type=style&index=0&id=34356cbc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports